export default __webpack_public_path__ + "static/media/02_drawing.d2486e6e.mp3";